export default {"src":"/_next/static/media/right-arrow.3aa8a2fc.svg","height":54,"width":30,"blurWidth":0,"blurHeight":0};